<div class="step-header">
  @for (step of steps(); track step.key; let i = $index, last = $last) {
    <div
      class="step"
      [class.active]="stepStates()[step.key]?.active"
      [class.completed]="stepStates()[step.key]?.completed"
      [class.pending]="stepStates()[step.key]?.pending"
      [class.fast-tracked]="stepStates()[step.key]?.fastTracked"
      [class.clickable]="stepStates()[step.key]?.completed"
      (click)="onStepClick(step.key)">
      <div class="step-circle">
        @if (stepStates()[step.key]?.fastTracked) {
          <i class="material-symbols-rounded">bolt</i>
        } @else if (stepStates()[step.key]?.completed) {
          <i class="material-symbols-rounded">check</i>
        } @else {
          <i class="material-symbols-rounded">{{ step.icon }}</i>
        }
      </div>
      <span class="step-label">{{ step.label }}</span>
      <i class="material-symbols-rounded mobile-arrow">chevron_right</i>
    </div>
    @if (!last) {
      <div class="step-connector" [class.completed]="stepStates()[step.key]?.completed"></div>
    }
  }
</div>
